export const trainingPhraseShortCircuitModes = {
  disabled: 'disabled',
  fallback: 'fallback',
  eager: 'eager',
  primary: 'primary',
}
